import * as React from 'react';
import * as Cx from 'classnames';
import { Link, Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';

import { events, EventData } from '../data/events';

import './events.css';

const eventsBackground = {
  backgroundImage: `url(${process.env.PUBLIC_URL + '/img/events_background.jpg'})`,
};

export default class EventsPage extends React.PureComponent<RouteComponentProps<{}>, {}> {
  get eventTabLinks(): JSX.Element[] {
    return events.map(event => (
      <li
        key={event.path}
        className={Cx({
          'is-active': this.props.location.pathname === event.path,
          'has-text-weight-semibold': this.props.location.pathname === event.path,
          'is-shadowed': this.props.location.pathname === event.path,
        })}
      >
        <Link to={event.path}>
          <span className="is-hidden-mobile">{event.title}</span>
          <span className="is-hidden-tablet">{event.mobileTitle || event.title}</span>
        </Link>
      </li>
    ));
  }

  get eventTabRoutes(): JSX.Element[] {
    return events.map(event => <Route key={event.path} path={event.path} render={this.eventTabContent(event)} />);
  }

  eventTabContent(event: EventData): () => JSX.Element {
    return () => (
      <section className="media">
        <div className="media-content">
          <div className="content">
            <h2 className="title is-3">{event.title}</h2>
            <h3 className="subtitle is-5 is-hidden-mobile">
              {event.time}
              {event.location ? (
                <span>
                  {' '}
                  at <a href={event.locationHref}>{event.location}</a>
                </span>
              ) : null}
            </h3>
            <h3 className="subtitle is-5 is-hidden-tablet is-close-bottom">{event.time}</h3>
            <h3 className="subtitle is-5 is-hidden-tablet is-close-top">
              <a href={event.locationHref}>{event.location}</a>
            </h3>
            <p>{event.description}</p>
            {event.attire ? (
              <p>
                <h6 className="subtitle is-6 is-close-bottom">ATTIRE</h6>
                {event.attire}
              </p>
            ) : null}
          </div>
        </div>
        <figure className="media-right is-hidden-mobile">
          <p className="image is-256x256">
            <img src={`${process.env.PUBLIC_URL}${event.imgSrc}`} />
          </p>
        </figure>
      </section>
    );
  }

  render(): JSX.Element {
    return (
      <section className="events section background escape-nav" style={eventsBackground}>
        <div className="container">
          <h1 className="title is-shadowed has-text-centered">Schedule of Events</h1>
          <div className="tabs is-boxed is-fullwidth">
            <ul>{this.eventTabLinks}</ul>
          </div>
          <Switch>
            {this.eventTabRoutes}
            <Redirect to="/events/ceremony" />
          </Switch>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/events.tsx